<template>
  <div class="b-menu-drop-target" :class="classes" :style="[position]"></div>
</template>

<script>
import DraggableFactory, { Types } from '../util/DragAndDrop'
import PositionManager from '../util/PositionManager'
import StyleConverter from '../util/StyleConverter'
import StoreHelper from '../store/helper'

export default {
  name: 'b-menu-drop-target',
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  mounted () {
    if (StoreHelper.isDraggableBubblesEnabled()) {
      DraggableFactory.register(Types.DROPPABLE, null, this.$el)
    }
  },
  activated () {
    if (StoreHelper.isDraggableBubblesEnabled()) {
      DraggableFactory.register(Types.DROPPABLE, null, this.$el)
    }
  },
  computed: {
    classes () {
      return {
        'b-menu-drop-target--emphasize': this.isFirstDropTarget
      }
    },
    position () {
      const position = PositionManager.getDropTargetPosition(this.index, -StoreHelper.getDefaultAngle())
      return StyleConverter.createDropTargetTransformation(position)
    },
    isFirstDropTarget () {
      return !this.index
    }
  },
  beforeDestroy () {
    if (StoreHelper.isDraggableBubblesEnabled()) {
      DraggableFactory.unregister(this.$el)
    }
  },
  deactivated () {
    if (StoreHelper.isDraggableBubblesEnabled()) {
      DraggableFactory.unregister(this.$el)
    }
  }
}
</script>

<style lang="scss" scoped>
.b-menu-drop-target {
  position: absolute;
  z-index: 1;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  transform-origin: 0% 100%;
}

.b-menu-drop-target--emphasize {
  z-index: 2
}

</style>
